/**
 * Envío PJ-2 · «Personalización del proyecto»: marca, reparto y plantilla que
 * usa el proyecto abierto, en un solo pedido.
 */
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const libraryService = {
  async personalization(projectId) {
    const { data } = await axios.get(`${API}/projects/${projectId}/personalization`);
    return data;
  },
};

export default libraryService;
